export const validateDriverName = (name) => {
    const regex = /^[A-Za-z\s]+$/;  
    return regex.test(name);
  };
  